import { useEffect, useState } from "react"
import InputAHSF from "../../Components/InputAHSF"
import AttachmentASFH from "../../Components/AttachmentsAHSF"
import ButtonAHSF from "../../Components/ButtonAHSF"
import { AddPR_ExchangeInformationItemAdministrativeCosts, GetPR_ExchangeInformationItemAdministrativeCostsByID } from "../../Redux/Reducers/ReportStage/ExchangeInformationItemAdministrativeCosts"
import axios from "axios"
import { useDispatch, useSelector } from "react-redux"
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables"
import $ from "jquery";
import { GetExchangeInformationItemImplementationStagesByID, ValidationExchangeInformationItemImplementation } from "../../Redux/Reducers/ReportStage/ExchangeDirectCost"
import { use } from "react"

const AddInformationDirectCost = (props) => {
    const validationShoman = useSelector((state) => state.ExchangeDirectCostReducers.ValidationExchangeInformationItemImplementation)
    const dispatch = useDispatch();
    const [invoiceNumber, setInvoiceNumber] = useState(null)
    const [beneficiaryContribution, setBeneficiaryContribution] = useState(null)
    const [shomanContribution, setShomanContribution] = useState(null)
    const [invoiceDetails, setInvoiceDetails] = useState(null)
    const [file, setFile] = useState()
    const [invoiceAttachment, setInvoiceAttachment] = useState(null)



    const [invoiceNumberValidation, setinvoiceNumberValidation] = useState(null)
    const [invoiceDetailsValidation, setinvoiceDetailsValidation] = useState(null)
    const [shomanContributionValidation, setShomanContributionValidation] = useState(null)
    const [beneficiaryContributionValidation, setBeneficiaryContributionValidation] = useState(null)
    const [validationStatus, setValidationStatus] = useState(false)
    const [fileValidation, setFileValidation] = useState()

    const [shomanContributionValidationMessagfe, setshomanContributionValidationMessagfe] = useState(false)
    const [beneficiaryContributionValidationMessagfe, setbeneficiaryContributionValidationMessagfe] = useState(false)

    const ExchangeInformationItemDirectCost = useSelector((state) => state.ExchangeDirectCostReducers.GetExchangeInformation)

    const state = useSelector((state) => {
        return {
            jsonData: state.FetchDataJson.JsonData,
            ActiveRound: state.ApplicationInformation.ActiveRound,
            ApplicationInformation:
                state.ApplicationInformation.ApplicationInformation,
        };
    });



    const validation = () => {
        let status1 = true
        let status2 = true

        let status3 = true

        let status4 = true

        let status5 = true
        let status6 = true
        let status7 = true
 console.log(validationShoman[0],"sssssdwddwdw");
        if (invoiceNumber == "null" || invoiceNumber == "" || invoiceNumber == null || invoiceNumber == undefined) {
            setinvoiceNumberValidation(true)
            console.log(invoiceNumber, "sdsdsd");
            status1 = false
        } else {
            setinvoiceNumberValidation(false)
            status1 = true
        }

        if (invoiceDetails == "null" || invoiceDetails == "" || invoiceDetails == null || invoiceDetails == undefined) {
            setinvoiceDetailsValidation(true)
            status2 = false
        } else {
            setinvoiceDetailsValidation(false)
            status2 = true
        }
        if (shomanContribution == "null" || shomanContribution == "" || shomanContribution == null || shomanContribution == undefined) {
            setShomanContributionValidation(true)
            status3 = false
        } else {
            setShomanContributionValidation(false)
            status3 = true
        }

        if (beneficiaryContribution == "null" || beneficiaryContribution == "" || beneficiaryContribution == null || beneficiaryContribution == undefined) {
            setBeneficiaryContributionValidation(true)
            status4 = false
        } else {
            setBeneficiaryContributionValidation(false)
            status4 = true
        }


        if (file == "null" || file == "" || file == null || file == undefined) {
            setFileValidation(true)
            status5 = false
        } else {
            setFileValidation(false)
            status5 = true
        }
        if (shomanContribution > validationShoman[0]?.remainingTotal) {
            setshomanContributionValidationMessagfe(true)
            console.log(validationShoman[0]?.totalValue,"sssssdwddwdw");
            
            status6 = false
        } else {
            setshomanContributionValidationMessagfe(false)
            status6 = true
        } if (beneficiaryContribution > validationShoman[1]?.remainingTotal) {
            console.log(validationShoman[0]?.totalValue,"sssssdwddwdw");
            setbeneficiaryContributionValidationMessagfe(true)
            status7 = false
        } else {
            setbeneficiaryContributionValidationMessagfe(false)
            status7 = true
        }

        return status1 && status2 && status3 && status4 && status5 && status6 && status7
    }

    useEffect(() => {
        dispatch(ValidationExchangeInformationItemImplementation({
            stageGuid: props.stageGuid,
            reportGuid: props.pR_ReportsId,
            applicationInfoGuid: localStorage.getItem("aI_ApplicationInformationId") || localStorage.getItem("aI_ApplicationInformationId_Manager"),
            estimatedBudgetForAdministrativeCostsId: props.PR_DirectCostsId
        }))
    }, [])
    const add = () => {


        if (validation()) {
            axios.post(`${state?.jsonData?.domainUrl}/api/ExchangDirectCost/AddpR_ExchangeInformationItemImplementationStages`, {
                PR_PR_DirectCostsId: props.PR_DirectCostsId,
                PR_ReportsStagesGuid: props.stageGuid,
                invoiceNumber: invoiceNumber,
                InvoiceDetails: invoiceDetails,
                ShomanContribution: shomanContribution,
                BeneficiaryContribution: beneficiaryContribution,
                file: file,
                invoiceAttachment: ""
            }, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }).then((result) => {
                dispatch(setRefreshTable());
                $("#AddInformationDirectCost").trigger("click"); // Simulate click to close modal

            }).catch((err) => {
                console.log(err);

            })
        }



    }

    useEffect(() => {
        if (props.action) {
            setInvoiceNumber(ExchangeInformationItemDirectCost?.invoiceNumber)
            setBeneficiaryContribution(ExchangeInformationItemDirectCost?.beneficiaryContribution)
            setShomanContribution(ExchangeInformationItemDirectCost?.shomanContribution)
            setInvoiceDetails(ExchangeInformationItemDirectCost?.invoiceDetails)
            setInvoiceAttachment(ExchangeInformationItemDirectCost?.invoiceAttachment)
        }

    }, [])

    const Update = () => {
        if (validation()) {
            axios.post(`${state?.jsonData?.domainUrl}/api/ExchangDirectCost/UpdatepR_ExchangeInformationItemImplementationStages`, {
                PR_ExchangeInformationItemAdministrativeCostsGUID: ExchangeInformationItemDirectCost.pR_ExchangeInformationItemImplementationStagesGUID,
                PR_EstimatedBudgetForAdministrativeCostsId: props.PR_DirectCostsId,
                PR_ReportsStagesGuid: props.stageGuid,
                invoiceNumber: invoiceNumber,
                InvoiceDetails: invoiceDetails,
                ShomanContribution: shomanContribution,
                BeneficiaryContribution: beneficiaryContribution,
                file: file,
                invoiceAttachment: ExchangeInformationItemDirectCost.invoiceAttachment
            }, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }).then((result) => {
                dispatch(setRefreshTable());
                $("#AddInformationDirectCost").trigger("click"); // Simulate click to close modal
            }).catch((err) => {

            })
        }


    }

    useEffect(() => {
        if (props.action) {
            dispatch(GetExchangeInformationItemImplementationStagesByID({ pR_ExchangeInformationItemImplementationStagesGUID: props.ExchangeInformationItemInformationDirectCostGUID }))

        }
    }, [props.ExchangeInformationItemInformationDirectCostGUID])

    console.log(ExchangeInformationItemDirectCost?.pR_ExchangeInformationItemImplementationStagesGUID
        , "ssdwdcdcdwdwdwd");

    const HTML = <>

        <div>
            <InputAHSF
                fieldsName="ExchangeAdminStrativeCostPopupinvoiceNumber"
                show={true}
                disabled={!props.canEdit}

                comma={false}
                onChange={(e) => {
                    setInvoiceNumber(e.target.value)
                }}
                defaultValue={props.action ? ExchangeInformationItemDirectCost?.invoiceNumber
                    : ""}
                showValidationMessage={
                    invoiceNumberValidation
                }
                validationMessage="يرجى تعبئة هذا الحقل"
            />

            <InputAHSF
                fieldsName="ExchangeAdminStrativeCostPopupInvoiceDetails"
                show={true}
                disabled={!props.canEdit}

                comma={false}
                onChange={(e) => {
                    setInvoiceDetails(e.target.value)
                }}
                defaultValue={props.action ? ExchangeInformationItemDirectCost?.invoiceDetails

                    : ""}
                showValidationMessage={
                    invoiceDetailsValidation
                }
                validationMessage="يرجى تعبئة هذا الحقل"
            />

            <InputAHSF
                fieldsName="ExchangeAdminStrativeCostPopupSchumanContributionDisbursementInformation"
                show={true}
                disabled={!props.canEdit}

                comma={false}
                onChange={(e) => {
                    setShomanContribution(e.target.value)
                }}
                defaultValue={props.action ? ExchangeInformationItemDirectCost?.shomanContribution

                    : ""}
                showValidationMessage={
                    shomanContributionValidation || shomanContributionValidationMessagfe
                }
                validationMessage="يرجى تعبئة هذا الحقل"
            />

            <p className="MessageValidationShoman">
                {shomanContributionValidationMessagfe ? "يرجى التأكد من أن قيمة الصرف الفعلي من مساهمة شومان للمرحلة لا تتجاوز إجمالي المتبقي من مساهمة شومان" : ""}
            </p>
            <InputAHSF
                fieldsName="ExchangeAdminStrativeCostPopupBeneficiaryContributionDisbursementInformation"
                show={true}
                disabled={!props.canEdit}

                comma={false}
                onChange={(e) => {
                    setBeneficiaryContribution(e.target.value);
                }}
                defaultValue={props.action ? ExchangeInformationItemDirectCost?.beneficiaryContribution


                    : ""}

                showValidationMessage={
                    beneficiaryContributionValidation || beneficiaryContributionValidationMessagfe
                }
                validationMessage="يرجى تعبئة هذا الحقل"
            />
            <p className="MessageValidationShoman">
                {beneficiaryContributionValidationMessagfe ? "يرجى التأكد من أن قيمة الصرف الفعلي من مساهمة المستفيد للمرحلة لا تتجاوز إجمالي المتبقي من مساهمة المستفيد" : ""}
            </p>

            <div style={{ marginTop: "10px" }}>
                <label className="labeInput">
                    مرفق وثيقة اثبات الشخصية
                    <span className="star">*</span>
                </label>
                <div style={{ marginTop: "20px" }}>
                    <AttachmentASFH
                        id={"hhhh"}
                        text={"انقر لتعديل المرفق"}
                        title={"إضافة مرفق"}
                        disabled={!props.canEdit}

                        show={true}
                        clear={false}
                        AttachementType="CoApplicantNames"
                        singleFile={
                            props.action ? ExchangeInformationItemDirectCost?.invoiceAttachment :
                                ""
                        }
                        readOnly={false}
                        onChange={(e) => {
                            setFile(e.target.files[0])
                            // setFileChange(fileChange + 1);
                            // setproofOfIdentityDocument(e.target.files[0]);

                            // setCoApplicantNamesData({
                            //     ...CoApplicantNamesData,
                            //     proofOfIdentityDocument: e.target.value, // التحديث هنا
                            // });
                        }}
                        validationMessage="يرجى تعبئة هذا الحقل"
                        showValidationMessage={
                            fileValidation
                        }
                    />
                </div>
            </div>
            {
                props.canEdit ? <>
                    <div className="containerButton">
                        <ButtonAHSF
                            onClick={
                                props.action ? Update :
                                    add
                            }
                            text={props.action ? "تعديل" : "حفظ"}
                            show={true}
                        />
                    </div>
                </> : <></>
            }

        </div>
    </>


    return (
        <>
            {
                props.action ? ExchangeInformationItemDirectCost?.pR_ExchangeInformationItemImplementationStagesGUID ? HTML : <></> : HTML
            }
        </>
    )
}

export default AddInformationDirectCost